import React, { useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { Text } from './ui';
import '../styles/Login.css';

function Welcome() {
  const [showAuthOptions, setShowAuthOptions] = useState(false);
  const [searchParams] = useSearchParams();

  // `/login` lands here, not on the form, so an invitation arriving at this
  // route has to survive the hop to /signup or /signin — otherwise the token
  // is dropped on the one screen that exists to choose between them.
  const invitationToken = searchParams.get('invitation');
  const withInvitation = (path) =>
    invitationToken ? `${path}?invitation=${invitationToken}` : path;

  return (
    <div className="login-container">
      <div className="welcome-content">
        <div className="logo-container">
          <img src="/FullLogo.png" alt="Housfully" className="logo" />
        </div>
        <Text tone="dark" className="welcome-tagline">
          Housfully AI is here
          <br />
          to help you with your remodel.
        </Text>
        <Text tone="dark" className="welcome-contact">
          We'd love to hear from you to understand how best we can help. Get in
          touch with us at{' '}
          <a href="mailto:hello@housfully.com">hello@housfully.com</a>
        </Text>
        <div
          className={`welcome-dropdown ${showAuthOptions ? 'welcome-dropdown-open' : ''}`}
        >
          <button
            className="welcome-dropdown-trigger"
            onClick={() => setShowAuthOptions(!showAuthOptions)}
          >
            Go to Preview Edition
            <svg
              className="welcome-dropdown-chevron"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.5"
            >
              <polyline points="6 9 12 15 18 9" />
            </svg>
          </button>
          <div className="welcome-dropdown-options">
            <Link
              to={withInvitation('/signup')}
              className="welcome-dropdown-option"
            >
              Create an Account
            </Link>
            <Link
              to={withInvitation('/signin')}
              className="welcome-dropdown-option"
            >
              Log In
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Welcome;
